import { removeToken } from "../reducers/auth";

export const tokenExpirationMiddleware = (store) => (next) => (action) => {
    if (action.meta && action.meta.rejectedWithValue && action.payload && action.payload.status === 401) {
      // Token expired or unauthorized, dispatch logout action
      store.dispatch(removeToken()); // Use the action from authApiSlice
    }
    return next(action);
};
